/**
 * Layout autenticado — equivale ao `app/(dashboard)/layout.tsx` do template.
 *
 * `beforeLoad` plays the AuthGuard role: it resolves the session before the
 * route mounts and redirects to /login when there is no user. Because it uses
 * `ensureQueryData`, the call is deduplicated and reused by the child screens.
 */
import Button from '@mui/material/Button'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import ScrollToTop from '@core/components/scroll-to-top'
import HorizontalLayout from '@layouts/horizontal-layout'
import LayoutWrapper from '@layouts/layout-wrapper'
import VerticalLayout from '@layouts/vertical-layout'
import { getSystemMode } from '@core/utils/server-helpers'

import { trpc } from '@/lib/trpc'

import HorizontalFooter from '@components/layout/horizontal/footer'
import Header from '@components/layout/horizontal/header'
import VerticalFooter from '@components/layout/vertical/footer'
import Navbar from '@components/layout/vertical/navbar'
import Navigation from '@components/layout/vertical/navigation'

export const Route = createFileRoute('/_dashboard')({
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient.ensureQueryData(trpc.auth.me.queryOptions())

    if (!user) {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }

    return { user }
  },
  component: DashboardLayout
})

function DashboardLayout() {
  const systemMode = getSystemMode()

  return (
    <>
      <LayoutWrapper
        systemMode={systemMode}
        verticalLayout={
          <VerticalLayout navigation={<Navigation mode={systemMode} />} navbar={<Navbar />} footer={<VerticalFooter />}>
            <Outlet />
          </VerticalLayout>
        }
        horizontalLayout={
          <HorizontalLayout header={<Header />} footer={<HorizontalFooter />}>
            <Outlet />
          </HorizontalLayout>
        }
      />
      <ScrollToTop className='mui-fixed'>
        <Button variant='contained' className='is-10 bs-10 rounded-full p-0 min-is-0 flex items-center justify-center'>
          <i className='tabler-arrow-up' />
        </Button>
      </ScrollToTop>
    </>
  )
}
